import { GiElectric } from 'react-icons/gi';
import { AiOutlineSafety } from 'react-icons/ai';
import { MdOutlineSchool } from 'react-icons/md'; // Advanced Model Training
import { MdOutlineCloudDone } from 'react-icons/md'; 
import img1 from "../../../../assets/img/Services/IotEdgeSolution/dan-lefebvre-mAwE-fqgDXc-unsplash.jpg"

export default function PaymentServices() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="md:grid flex flex-col-reverse md:grid-cols-2 gap-8 items-center">
      <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            Smart Building Systems
            </h1>
            <p className="text-lg text-gray-600">
            Deploy IoT-powered systems for energy optimization, HVAC monitoring, security, and predictive maintenance.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <GiElectric className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Energy Optimization</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Implement IoT-powered systems to monitor and optimize energy usage, reducing costs and improving sustainability in smart buildings.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <AiOutlineSafety className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Predictive Maintenance & Security</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Use IoT sensors for real-time monitoring of HVAC systems and security, enabling predictive maintenance and enhancing safety and efficiency.
              </p>
            </div>

           
          </div>
        </div>

      
      </div>
    </div>
  )
}